import AppStore from './AppStore';

export default new AppStore();
